var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro h-screen"},[(_vm.currentPage == 0)?_c('IntroFirstPage'):_vm._e(),(_vm.currentPage == 1)?_c('IntroSecondPage'):_vm._e(),(_vm.currentPage == 2)?_c('IntroThirdPage'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }